// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-header[data-v-1d877b8c]{padding:2rem 0;display:flex;flex-flow:column nowrap}.section-header .body-copy[data-v-1d877b8c]{max-width:60%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
